import React from 'react';
import { useHistory } from 'react-router-dom';
import { History } from 'history';
import { Row, Input, Form, Typography, Button } from 'antd';
import i18n from 'i18next';

export const AddBankAccount: React.FC = () => {
  const history: History = useHistory();
  const layout = {
    wrapperCol: { span: 22 },
  };

  const handleSkipButton = () => {
    history.push('/profile');
  };

  return (
    <Row className="add-bank-wrapper">
      <Typography.Text>{i18n.t('ACCOUNT_DETAILS')}</Typography.Text>
      <Form
        {...layout}
        size="middle"
        name="add-bank-account"
        className="add-bank-form"
      >
        <div className="form-block">
          <Form.Item
            name="holder_name"
            rules={[{ required: true, message: i18n.t('INPUT_HOLDERS_NAME') }]}
          >
            <Input placeholder={i18n.t('CARDHOLDER_NAME')} />
          </Form.Item>

          <Form.Item
            name="account_number"
            rules={[
              { required: true, message: i18n.t('INPUT_ACCOUNT_NUMBER') },
            ]}
          >
            <Input placeholder={i18n.t('ACCOUNT_NUMBER')} />
          </Form.Item>

          <Form.Item
            name="iban"
            rules={[{ required: true, message: i18n.t('INPUT_IBAN') }]}
          >
            <Input placeholder={i18n.t('IBAN')} />
          </Form.Item>

          <Form.Item
            name="swift_code"
            rules={[{ required: true, message: i18n.t('INPUT_SWIFT_CODE') }]}
          >
            <Input placeholder={i18n.t('SWIFT_CODE')} />
          </Form.Item>

          <Form.Item
            name="bank_name"
            rules={[{ required: true, message: i18n.t('INPUT_BANK_NAME') }]}
          >
            <Input placeholder={i18n.t('BANK_NAME')} />
          </Form.Item>

          <Form.Item
            name="bank_address"
            rules={[{ required: true, message: i18n.t('INPUT_BANK_ADDRESS') }]}
          >
            <Input placeholder={i18n.t('BANK_ADDRESS')} />
          </Form.Item>

          {/* UNCOMMENT TO DISPLAY */}
          {/* <div className="threshold-container">
            <Typography.Text>{i18n.t('PAYMENT_THRESHOLD')}</Typography.Text>
            <Typography.Paragraph className="threshold-description">
              {i18n.t('PAYMENT_THRESHOLD_MESSAGE')}
            </Typography.Paragraph>
            <Form.Item
              name="threshold"
              rules={[{ required: true, message: i18n.t('PAYMENT_THRESHOLD') }]}
              wrapperCol={{ span: 12 }}
              labelCol={{ span: 4 }}
            >
              <div className="threshold-inner-content">
                <Input placeholder="1.00" />
                <span style={{ verticalAlign: 'middle' }}>Kč</span>
                // <FaEuroSign style={{ verticalAlign: 'middle' }} /> // HIDE EURO SYMBOL
              </div>
            </Form.Item>
          </div> */}
        </div>

        <Form.Item className="form-bottom-item">
          <div className="primary-button-basic-container">
            <Button
              shape="round"
              className="primary-button-basic"
              htmlType="submit"
            >
              {i18n.t('Continue')}
            </Button>
          </div>
          <Button
            type="link"
            block
            className="skip-button"
            onClick={handleSkipButton}
          >
            {i18n.t('SKIP')}
          </Button>
        </Form.Item>
      </Form>
    </Row>
  );
};
